

import $ from 'jquery';
import Component from './component';
import createComponentFactory from '../createComponent';
import headerPanel from './headerPanel';
import headerPanelTrigger from './headerPanelTrigger';
import { HeaderPanelActionType, WindowActionType } from '../constant/actionType';
import { TweenMax } from 'gsap/umd/TweenMax';


class PageHeaderCompact extends Component {

  constructor(element, context, options) {
    super(element, context, options);
    this.$nav = $('.l-pageHeaderCompact__nav');

    this.headerBar = element.querySelector('.js-pageHeaderCompact__bar');
    this.headerContent = element.querySelector('.js-pageHeaderCompact__content');
    this.headerPanel = element.querySelector('.js-headerPanel');
    this.headerPanelTrigger = element.querySelector('.js-headerPanelTrigger');
    this.headerObserver = new IntersectionObserver((changes) => {
      for(let change of changes) {

        if(change.isIntersecting) {
          this._unstickHeader();
        } else {
          this._stickHeader();
        }

      }
    }, {
      threshold: [0]
    });

    this.headerObserver.observe(this.headerBar);

    this._handleShowHeaderPanel = this._handleShowHeaderPanel.bind(this);
    this._handleHideHeaderPanel = this._handleHideHeaderPanel.bind(this);
    this._handleWindowLoad = this._handleWindowLoad.bind(this);
  }

  _addEvents() {
    this.context.dispatcher.on(HeaderPanelActionType.SHOW_HEADER_PANEL, this._handleShowHeaderPanel);
    this.context.dispatcher.on(HeaderPanelActionType.HIDE_HEADER_PANEL, this._handleHideHeaderPanel);
    this.context.dispatcher.on(WindowActionType.WINDOW_LOAD, this._handleWindowLoad);
  }

  _removeEvents() {
    this.context.dispatcher.off(HeaderPanelActionType.SHOW_HEADER_PANEL, this._handleShowHeaderPanel);
    this.context.dispatcher.off(HeaderPanelActionType.HIDE_HEADER_PANEL, this._handleHideHeaderPanel);
    this.context.dispatcher.off(WindowActionType.WINDOW_LOAD, this._handleWindowLoad);
  }

  _handleWindowLoad() {

    if(location.hash.length === 0) {
      return;
    }

    window.scrollTo(0, window.pageYOffset - this.element.clientHeight);
  }

  _handleShowHeaderPanel() {

    this._showHeaderPanel();
  }

  _handleHideHeaderPanel() {
    this._hideHeaderPanel();
  }

  _showHeaderPanel() {
    this.element.dataset.active = 'panel';

    this.$nav.show();

    TweenMax.fromTo('.l-headerPanel' , 0.2 , {
      x: '-100%',
    },{
      x: '0%',
    });
  }

  _hideHeaderPanel() {
    this.element.removeAttribute('data-active');

    TweenMax.fromTo('.l-headerPanel' , 0.2 , {
      x: '0%',
    }, {
      x: '-100%',
      onComplete: () => {
        this.$nav.hide();
      }
    });
  }

  _stickHeader() {
    this.headerContent.dataset.sticky = true;
  }

  _unstickHeader() {
    delete this.headerContent.dataset.sticky;
  }

  didRegisterComponent() {
    this._addEvents();


    this.registerComponent('headerPanel', this.headerPanel, headerPanel);
    this.registerComponent('headerPanelTrigger', this.headerPanelTrigger, headerPanelTrigger);
  }

  didUnregisterComponent() {
    this._removeEvents();

    this.unregisterComponent('headerPanel');
    this.unregisterComponent('headerPanelTrigger');
  }
}

export default createComponentFactory(PageHeaderCompact);



// WEBPACK FOOTER //
// ./src/js/app/component/pageHeaderCompact.js